import { jsx } from "panel";
export function template() {
  const {
    inputValue,
    inputWidth
  } = this.state;
  return /* @__PURE__ */ jsx("div", { sel: ".autoresizing-input-input-container", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("input", { sel: ".remove-chrome-form-style", attrs: {
    readonly: this.attr("disabled"),
    placeholder: this.attr("placeholder")
  }, class: {
    ["autoresizing-input-theme-".concat(this.attr("theme"))]: true
  }, props: Object.assign({
    type: "text",
    value: inputValue
  }, this.attr("max-length") ? {
    maxLength: this.attr("max-length")
  } : {}), style: Object.assign({
    width: "".concat(inputWidth, "px")
  }, this.attr("input-style-overrides")), on: {
    input: this.helpers.updatedInput,
    focus: this.helpers.handleFocus,
    blur: this.helpers.handleBlur,
    keypress: this.helpers.propagateEvent,
    change: this.helpers.propagateEvent
  }, hook: {
    insert: this.helpers.inserted,
    postpatch: (_, vnode) => this.helpers.inserted(vnode)
  } }));
}
